import { BACKOFFICE_CONFIGS } from "utils/constants";
import { useSingleAppConfigurationValue } from "./use-single-configuration-value";

export function useGlAccountSize() {
  const glAccountSize = useSingleAppConfigurationValue(
    BACKOFFICE_CONFIGS.GL_ACCOUNT_NUMBER_SIZE
  );
  return glAccountSize;
}
